import bestToPayDictionary from '../../ru/best-to-pay/best-to-pay.dic.json';

export const bestToPayNS = {
  BEST_TO_PAY: bestToPayDictionary,
};

export const bestToPayNamespaces = ['BEST_TO_PAY'];
